export const getSubmittedMessagesList = (state) => state.messages.submitted.message_list ?? [];
export const getSubmittedMessagesCount = (state) => state.messages.submitted.message_count ?? 0;

export const getUnsubmittedMessagesList = (state) => state.messages.unsubmitted.message_list ?? [];
export const getUnsubmittedMessagesCount = (state) => state.messages.unsubmitted.message_count ?? 0;
